module.exports = __webpack_public_path__ + "static/img/4100_phase_function_Paper_PointsHejduk_Prediction.f4d861d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4100_phase_function_Paper_PointsHejduk_Prediction.png
// module id = wr3I
// module chunks = 0